export default __webpack_public_path__ + "static/media/slider1.9641d34e.png";